import { hashKey, type QueryClient, type QueryKey } from "@tanstack/react-query";

const deferred = new WeakMap<QueryClient, Map<string, QueryKey[]>>();

/**
 * The keys to reconcile now: none while another mutation of the group is
 * pending, whose last one then takes every key the earlier ones left, so a
 * refetch never lands between two optimistic paints of the same entity.
 */
export function keysToSettle(
  client: QueryClient,
  group: string | undefined,
  keys: readonly QueryKey[],
): readonly QueryKey[] {
  if (group === undefined) return keys;
  const pending = deferred.get(client) ?? new Map<string, QueryKey[]>();
  deferred.set(client, pending);
  const queued = [...(pending.get(group) ?? []), ...keys];
  if (client.isMutating({ mutationKey: [group] }) > 1) {
    pending.set(group, queued);
    return [];
  }
  pending.delete(group);
  return [...new Map(queued.map((queryKey) => [hashKey(queryKey), queryKey])).values()];
}
